<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-text-field
        v-model="searchVal"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getDataFromApi()"
        @keydown="checkKeypress"
      />
    </v-col>

    <v-col cols="12" style="position: relative;">
      
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="primary"
          :to="{name: 'system-admin-partnerships-create'}"
          v-if="$store.getters.userIs('systemAdmin')"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>

        <v-data-table
          :headers="headers"
          :items="partnerships"
          :options.sync="options"
          :server-items-length="totalPartnerships"
          :footer-props="tableFooterProps"
          :loading="loading"
          @click:row="partnershipClicked"
        >
          

          <template v-slot:[`item.name`]="{ item }">
            <div class="py-2">{{ item.name }}</div>
          </template>
          <template v-slot:[`item.referral_link`]="{ item }">
            <v-text-field
              readonly
              :value="item.referral_link"
              outlined
              dense
              hide-details
              @click.stop="copyInviteLink(item, $event)"
            />
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ $moment.unix(item.created_at).calendar() }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'AdminPartnershipIndex',
  data: () => ({
    loading: true,
    searchVal: null,
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      },
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Invite Link',
        align: 'start',
        sortable: false,
        value: 'referral_link'
      },
      {
        text: 'Created',
        align: 'start',
        value: 'created_at',
        width: '250px'
      }
    ],
    partnerships: [],
    totalPartnerships: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  mounted() {
    //this.getDataFromApi()
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let qParams = []

      this.loading = true
      if(sortBy[0]) qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0])
      qParams.push('per-page=' + itemsPerPage)
      qParams.push('page=' + page)
      if(this.searchVal) qParams.push('s=' + encodeURIComponent(this.searchVal))

      this.$http.get('partnerships?' + qParams.join('&'))
        .then(response => {
          this.partnerships       = response.data.items
          this.totalPartnerships  = response.data._meta.totalCount
        })
        .catch(err => {
          if(err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading users', 'error')
        })
        .finally(() => {
          this.loading = false
        })

    },
    partnershipClicked(partnership) {
      if(this.$store.getters.userIs('systemAdmin')) this.$router.push({name: 'system-admin-partnerships-edit', params:{partnership_id: partnership.id}})
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getDataFromApi()
    },
    copyInviteLink(item, e) {
      e.target.select()
    }
  }
}
</script>